export default __webpack_public_path__ + "static/poc-41ee0c6e6e81b5f1548ab47c0f422a2d.jpeg";